type PreferenceLineProps = {
  title: string;
  value: string[];
};

export const PreferenceLine = ({ title, value }: PreferenceLineProps) => {
  return (
    <div className="flex flex-col items-start justify-between border-0 border-b border-gray-200 py-4 sm:flex-row sm:items-end">
      <div className="flex flex-1 flex-col">
        <p className="text-sm font-medium text-gray-600">{title}</p>
      </div>
      <div className="flex flex-1 flex-col">
        {value.map((value, index) => {
          return (
            <p className="text-base font-medium text-gray-700" key={index}>
              {value}
            </p>
          );
        })}
      </div>
    </div>
  );
};
